// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration - hardcoded for S3 deployment
const firebaseConfig = {
  apiKey: "AIzaSyClTeIL7d6mGgpA2fQ9biV8DpEEq9hfuGc",
  authDomain: "gensurf-co.firebaseapp.com",
  projectId: "gensurf-co",
  storageBucket: "gensurf-co.firebasestorage.app",
  messagingSenderId: "1037928348492",
  appId: "1:1037928348492:web:26a6399d747a6e8198ade9",
  measurementId: "G-33L7XJ5JE0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;